export default __webpack_public_path__ + "static/media/shop3.66cf2ded.jpg";